import { useState, useEffect, createContext, useContext } from 'react';
import api from '../services/api';

const SeoContext = createContext({});

export function SeoProvider({ children }) {
    const [seoConfig, setSeoConfig] = useState(null);

    useEffect(() => {
        api.get('/seo.php?action=config')
            .then(res => setSeoConfig(res.data))
            .catch(() => setSeoConfig({}));
    }, []);

    return (
        <SeoContext.Provider value={seoConfig}>
            {children}
        </SeoContext.Provider>
    );
}

/** Returns the full SEO config map, or {} if not loaded yet. */
export function useSeoConfig() {
    return useContext(SeoContext) || {};
}

/** Returns per-page SEO override for a given page key, e.g. 'page_home'. */
export function usePageSeo(pageKey) {
    const config = useSeoConfig();
    return config?.[pageKey] || {};
}
